import { Helmet } from "react-helmet-async";

type Props = {
  title: string;
  description: string;
  url: string;
  ogImage?: string;
};

export default function SEO({ title, description, url, ogImage }: Props) {
  const defaultOgImage =
    "https://pub-bb2e103a32db4e198524a2e9ed8f35b4.r2.dev/90161016-c4d8-491f-891c-2bbcf8d61516/id-preview-7337c40d--a5285790-fc3d-45cf-8ef9-8f156cc952e3.lovable.app-1783535095050.png";

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={ogImage || defaultOgImage} />
      <meta property="og:site_name" content="Motosport Software" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage || defaultOgImage} />

      <meta
        name="keywords"
        content="dealer workflow software, automotive software, powersports software, vehicle inventory management, dealer acquisition, vehicle transportation, automotive technology"
      />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Motosport Software",
          url: "https://motosportsoftware.com",
          description: description,
          sameAs: ["https://www.linkedin.com/company/motosport-software"],
        })}
      </script>
    </Helmet>
  );
}
